import { z } from "zod";

export const AnnouncementTypeCodes = {
  Info: 100000000,
  Feature: 100000001,
  Beta: 100000002,
  New: 100000003,
  Info2: 100000004,
  Deploy: 100000005,
  Deprecate: 100000006,
} as const;

export type AnnouncementTypeCode =
  (typeof AnnouncementTypeCodes)[keyof typeof AnnouncementTypeCodes];

export const NotificationAnnouncementItemSchema = z.object({
  Id: z.string(),
  Description: z.string().optional(),
  Name: z.string().optional(),
  Title: z.string().optional(),
  TypeCode: z.number().optional(),
  DetailsUrl: z.string().optional(),
});

export type NotificationAnnouncementItemType = z.infer<
  typeof NotificationAnnouncementItemSchema
>;
